var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMapMarkerColored(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "g2505",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2511",
    d: "M0-682.665H21v21H0Z",
    transform: "translate(0 682.665)",
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "g2507"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g2509",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g2515",
    transform: "translate(3.732 0.615)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2517",
    d: "M-213.232-622.9c-2.461-3.691-6.768-8.7-6.768-13a6.775,6.775,0,0,1,6.768-6.768,6.775,6.775,0,0,1,6.768,6.768C-206.464-631.591-210.771-626.587-213.232-622.9Z",
    transform: "translate(219.999 642.665)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "g2519",
    transform: "translate(7.424 4.307)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2521",
    d: "M-96.924-193.847A3.08,3.08,0,0,1-100-196.923,3.08,3.08,0,0,1-96.924-200a3.08,3.08,0,0,1,3.076,3.076A3.08,3.08,0,0,1-96.924-193.847Z",
    transform: "translate(100 200)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapMarkerColored);
export default __webpack_public_path__ + "static/media/map-marker-colored.41ee889b01a9adaec8f8148755988a64.svg";
export { ForwardRef as ReactComponent };